import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { Customer } from 'src/app/interfaces/customer';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-mangage-payment-methods',
    templateUrl: './mangage-payment-methods.component.html',
    styleUrls: ['./mangage-payment-methods.component.scss'],
    standalone: false
})
export class MangagePaymentMethodsComponent {
  userProfile?: UserProfile;
  customer?: Customer;
  companyType: string = '';

  constructor(private generalService: GeneralService,
    private authenticationService: AuthenticationService,
    private router: Router) { }

  scrollToTop() {
      window.scrollTo(0, 0);
  }

  ngOnInit(): void {
      window.onbeforeunload = null;
      this.customer = {};
      this.userProfile = this.authenticationService.getUserProfile();
      if (!this.userProfile!.customerId || this.userProfile!.customerId === '2147483647' || !this.userProfile!.customer) {
          this.router.navigateByUrl('/accessDenied');
      }

      this.customer = this.userProfile!.customer;
      const differentBillingUser = (this.customer.primaryBillingAreSame ?? '') === "0" || (this.customer.primaryBillingAreSame ?? '').toLowerCase() === 'false';
      const isPowerUser = this.customer.powerUserEmail?.toLowerCase() === this.userProfile!.userData.email.toLowerCase();
      const isBillingUser = differentBillingUser && (this.customer.billingInfo!.contactEmailId ?? '').toLowerCase() === this.userProfile!.userData.email.toLowerCase();
      if (!isPowerUser && !isBillingUser) {
          this.router.navigateByUrl('/accessDenied');
      }

      // This one is for you Danny...
      this.companyType = this.customer.customerType === 1 ?
          'MC' :
          this.customer.customerType === 6 ?
              'ISP' :
              '';

       setTimeout(() => this.scrollToTop(), 500);
  }

  openDocument(docName: string) {
      this.generalService.openDocument(docName);
  }

  userEmail():string {
      return this.generalService.maskEmail(this.userProfile!.userData.email);
  }


}
